/**
 * Local-only admin break-glass helpers.
 * Never true against staging/prod API hosts — even if REACT_APP_ENV is mis-set.
 */

export function isLocalApiHost(apiUrl = process.env.REACT_APP_API_URL) {
  const raw = apiUrl || 'http://localhost:4000/graphql';
  try {
    const host = new URL(raw).hostname;
    return host === 'localhost' || host === '127.0.0.1';
  } catch {
    return false;
  }
}

/** Allow ADMIN session without MFA only when talking to a local API. */
export function allowAdminWithoutMfa() {
  return isLocalApiHost();
}
